import { UserAuth } from './../store/features/auth/type'
import jwtDecode from 'jwt-decode'

const decodeToken = (accessToken: string): UserAuth => {
  const tokenDecode: Record<string, any> = jwtDecode(accessToken)

  const { role, name, family, nationalcode, exp, sub, phonenumber, provincebrokerid } = tokenDecode
  const userRole = typeof role === 'string' ? [role] : role

  return {
    userId: sub,
    accessToken: accessToken,
    role: userRole,
    provinceBrokerId: provincebrokerid,
    name,
    family,
    nationalCode: nationalcode,
    phoneNumber: phonenumber,
    exp,
  }
}
export default decodeToken
